<template>
  <div class="layout">
    <div class="header">
      <div class="logo">省局药品智慧监管平台</div>
      <div class="nav-level1">
        <ul class="nav-list">
          <li
            v-for="(item, index) in navLevel1List"
            :class="['nav-item', { active: currentIndex === index }]"
            :key="item.title"
            @click="handleClick(index)"
          >
            <router-link :to="item.path" class="link">
              <img
                :src="
                  currentIndex === index
                    ? require(`./images/${item.icon}.png`)
                    : require(`./images/${item.icon}_active.png`)
                "
                alt=""
                class="nav-img"
              />
              <span>{{ item.title }}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="system-info">
        <span class="welcome">欢迎{{ userInfo.userRealname }}登录系统</span>
        <span class="time">{{ currentTime }} {{ currentDate }}</span>
        <span @click="exit" class="exit">
          <img
            src="./images/logout.png"
            alt=""
            width="18px"
            class="logout-img"
          />
          <span class="logout">退出</span>
        </span>
      </div>
    </div>
    <div class="nav-level2">
      <ul class="nav-list">
        <li
          class="nav-item"
          v-for="(item, index) in navLevel2List"
          :key="item.path"
        >
          <router-link :to="item.path" class="link">{{
            item.title
          }}</router-link>
          <span class="border" v-show="index < navLevel2List.length - 1"
            >|</span
          >
        </li>
      </ul>
    </div>
    <div class="content-container">
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
  data() {
    return {
      navLevel1List: [],
      navLevel2List: [],
      currentIndex: 0,
      currentDate: new Date().format('yyyy-MM-dd'),
      currentTime: new Date().format('yyyyMMddhh:mm').substring(8)
    };
  },
  computed: {
    ...mapState(['menus', 'level1CurrentIndex', 'userInfo'])
  },
  mounted() {
    this.getTime();
    this.currentIndex = this.level1CurrentIndex;
    this.navLevel1List = this.menus.map(item => ({
      title: item.title,
      icon: item.icon,
      path: item.children[0].path
    }));
    this.navLevel2List = this.menus[this.currentIndex].children;
  },
  methods: {
    getTime() {
      const time = setInterval(() => {
        this.currentDate = new Date().format('yyyy-MM-dd');
        this.currentTime = new Date().format('yyyyMMddhh:mm').substring(8);
        if (this.currentTime.substring(this.currentTime.length - 2) === '00') {
          clearInterval(time);
          setInterval(() => {
            this.currentDate = new Date().format('yyyy-MM-dd');
            this.currentTime = new Date().format('yyyyMMddhh:mm').substring(8);
          }, 60000);
        }
      }, 1000);
    },
    handleClick(index) {
      this.currentIndex = index;
      this.navLevel2List = this.menus[index].children;
    },
    exit() {
      this.$confirm('即将退出系统登陆，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$request({
            url: 'logout'
          }).then(() => {
            window.location.href = '/login';
          });
        })
        .catch(() => {
          return false;
        });
    },
    ...mapMutations(['setLevel1CurrentIndex'])
  },
  watch: {
    $route() {
      this.setLevel1CurrentIndex(this.currentIndex);
    }
  }
};
</script>

<style lang="stylus" scoped>
.layout
  min-width 1440px
  position relative
  color #fff
  height 100%
  .header
    background #1D52C0
    height 60px
    line-height 60px
    padding 0 20px
    position relative
    .logo
      font-size 18px
      float left
      margin-right 50px
      padding-left 52px
      background url('./images/national-emblem.png') no-repeat
      background-size 36px
      background-position left center
    .nav-level1
      float left
      font-size 14px
      .nav-list
        overflow hidden
        position absolute
        bottom 0
        .nav-item
          height 40px
          line-height 40px
          float left
          width 120px
          border-radius 8px 8px 0 0
          cursor pointer
          margin-right 8px
          background rgba(61, 114, 234, .3)
          &.active
            background #3D72EA
          .link
            color #CEDBEF
            padding 0 15px
            display block
            width 90px
            .nav-img
              width 15px
              height 15px
              vertical-align middle
              margin-top -3px
              margin-right 5px
            &.router-link-active
              color #fff
    .system-info
      float right
      font-size 12px
      .time
        margin 0 10px
        padding-right 20px
        border-right 1px solid #FFFFFF
      .exit
        cursor pointer
        .logout-img
          vertical-align middle
          margin-top -3px
          margin-right 8px
          margin-left 12px
  .nav-level2
    position absolute
    left 0
    right 0
    background #3D72EA
    height 32px
    line-height 32px
    padding 0 30px
    z-index 100
    .nav-list
      overflow hidden
      .nav-item
        float left
        font-size 12px
        text-align center
        color #CEDBEF
        .link
          color #CEDBEF
          display inline-block
          height 100%
          margin 0 20px
          &.router-link-active
            color #FEFEFF
            background rgba(29, 82, 192, .4)
            padding 0 10px
        .border
          float right
          color rgba(206, 219, 239, 0.2)
  .content-container
    padding 80px 40px
    background #D9E4F4
    position absolute
    top 60px
    left 0
    right 0
    bottom 0
    overflow auto
    .content
      width 1300px
      margin 0 auto
</style>
